module.exports = __webpack_public_path__ + "img/slider_text_d1.4f3f307.d30ec57f.png";